import ProductLoader from "./ProductLoader.js"

export default function ProductCategoryLoader() {
    const loadingProductList = [...Array(6)].map((item, index) => <ProductLoader key={index} />)

    return (
        <div className="row mt-4 mb-5">
            <span className="col-12">
                <span className="placeholder placeholder-lg placeholder-wave bg-secondary col-4 h5"></span>
            </span>
            {loadingProductList}
        </div>
    )
}